import { Contract } from '../../../../common/validations'

export const resolveContractLabel = ({
  realPropertyName,
  postalAddress,
}: Pick<Contract, 'realPropertyName' | 'postalAddress'>) => {
  if (postalAddress) {
    if (postalAddress.streetAddressLine1.length > 0) {
      return postalAddress.streetAddressLine1
    }
  }

  if (realPropertyName.length > 0) {
    return realPropertyName
  }

  return ''
}
